import { render, staticRenderFns } from "./EducationSection.vue?vue&type=template&id=ad49d70c&scoped=true&"
import script from "./EducationSection.vue?vue&type=script&lang=ts&"
export * from "./EducationSection.vue?vue&type=script&lang=ts&"
import style0 from "./EducationSection.vue?vue&type=style&index=0&id=ad49d70c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad49d70c",
  null
  
)

export default component.exports